import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../../../../../Dialogs/ConfirmationModal";
import { Color } from "../../../../../../Form/Button";
import useStyles from "./styles";

export interface DeleteDocumentConfirmationModalHandles {
  open: (id: number, documentName?: string) => void;
  close: () => void;
}
interface DeleteDocumentConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: () => void;
  loadingAction?: boolean;
}

const DeleteDocumentConfirmationModal: ForwardRefRenderFunction<
  DeleteDocumentConfirmationModalHandles,
  DeleteDocumentConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [id, setId] = useState<number>();
  const [document, setdocument] = useState<string>("s");

  const open = useCallback((id: number, documentName?: string) => {
    setId(id);
    setdocument(documentName || "");
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setId(undefined);
    setdocument("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));
  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };
  const onDelete = () => {
    onSubmit();
  };

  return (
    <ConfirmationModal
      data-cy="deleteModal"
      width="520px !important"
      open={openModal}
      closeModal={onClose}
      type="error"
      title={translate("deleteDocument")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("cancel")}
      textSubmit={translate("delete")}
      submit={onDelete}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.cancelModalContainer}>
          <div data-cy="confirmationModalCancelBody" className={classes.descriptionModalConfirm}>
            <span>
              {`${translate("areYouSureYouWantToDelete")} "${document}" ${translate(
                "document"
              ).toLowerCase()}?`}
            </span>
            <span className="error">
              {translate("thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt")}
            </span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(DeleteDocumentConfirmationModal);
